import React from "react";
import { KTMScreen, ActionEvent, RenderEvent, renderScreen } from "ktm-ui";
import { KTMApi } from "api/KTMApi";
import { Layout, Button, DataGrid, IDataGridLayout, EmptyState } from "ktm-ui";
import EmployeeAddScreen from "enroll/employee/Add";
import EmployeeRecordScreen from "enroll/employee/Record";
import BulkUploadEmployees from "enroll/employee/Upload";
import axios from "axios";
import toastr from "toastr";
import { Modal } from "react-bootstrap";

interface IdsEmployees {
  Id: string;
  Policy_Id: string;
  FirstName: string;
  LastName: string;
  Email: string;
  DateOfBirth: string;
  BenefitCategory: string;
  TerminationDate: string;
  BenefitEndDate: string;
  HireDate: string;
  CreatedAt: string;
  CreatedByName: string;
}

export default KTMScreen(
  { name: "enroll.policy.employees" },
  class extends React.Component<{ policy_id: string, enrollment_status?: string }> {
    private screen: any;
    private uploadModalCloseResolver: (() => void) | null = null;

    data: {
      dsEmployees: IdsEmployees;
    };

    state = {
      filterText: "",
      collection: null,
      allEmployees: null,
      filteredEmployees: null,
      firstRun: true,
      submitDisabled: false,
      showDeactivatedEmployees : this.props.enrollment_status === "Pending",
      showPendingDeactivatedEmployees : false,
      showUploadModal: false
    };

    render() {
      return renderScreen(this);
    }

    handleChange(e) {
      this.setState({ filterText: e.target.value, firstRun: false });
      if (e.target.value == "") {
        let val = this.state.filteredEmployees;
        this.setState({ activeEmployees: val });
        if (this.state.showDeactivatedEmployees) {
          this.setState({ filteredEmployees: this.getInactiveEmployees() });
        } else if(this.state.showPendingDeactivatedEmployees){
          this.setState({ filteredEmployees: this.getPendingInactiveEmployees() });
        } else {
          this.setState({ filteredEmployees: this.getActiveEmployees() });
        }
      }
    }

    reset() {
      this.setState({
        filterText: "",
        submitDisabled: false,
        filteredEmployees: this.state.showDeactivatedEmployees
          ? this.getInactiveEmployees()
          : this.state.showPendingDeactivatedEmployees
            ? this.getPendingInactiveEmployees()
            : this.getActiveEmployees(),
      });
    }
    
    handleClick() {
      this.setState({ submitDisabled: true });
      let array = this.state.filteredEmployees;

      if (this.state.filterText != "") {
        let val = this.state.filterText;
        let regex = new RegExp(val.toLowerCase());
        let filteredArray = new Array<any>();
        array.rows.forEach((element) => {
          if (element.FirstName == null) {
            element.FirstName = "";
          }
          if (element.LastName == null) {
            element.LastName = "";
          }
          if (element.Email == null) {
            element.Email = "";
          }
          if (
            regex.test(element.FirstName.toLowerCase()) || 
            regex.test(element.LastName.toLowerCase()) || 
            regex.test(element.Email.toLowerCase()) || 
            regex.test(element.FirstName.toLowerCase() + " " + element.LastName.toLowerCase())) {
            filteredArray.push(element);
          }
        });
        array.rows = filteredArray;
      }
      this.setState({ filteredEmployees: array });
    }

    handleKeyPress = (e) => {
      if (e.key == "Enter") {
        this.handleClick();
      }
    };

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsEmployees";
      await KTMApi.start(screen, {
        "@policy_id": this.props.policy_id,
      });
      this.setState({firstRun: true});
      screen.title = "Employees";
    }

    checkIsEligibleToAddEmployee = async () => {
      try {
        const response = await axios.get("/api/Utility/checkeligiblityofaddingemployee?policyId=" + this.props.policy_id);
    
        if (response.data.success) {
          this.setState({ addDisabled: !response.data.isEligible });
          return !response.data.isEligible;
        } else {
          this.setState({ addDisabled: false });
          return false;
        }
      } catch (error) {
        return false;
      }
    }

    renderUploadModal() {
      if (!this.state.showUploadModal) return null;
      const closeModal = () => {
        this.setState({ showUploadModal: false });
        this.uploadModalCloseResolver?.();
        this.uploadModalCloseResolver = null;
      };
      return (
        <Modal show centered scrollable size="lg" onHide={closeModal}>
          <Modal.Body style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
            <BulkUploadEmployees
              policy_id={this.props.policy_id}
              onClose={closeModal}
            />
          </Modal.Body>
        </Modal>
      );
  }

    main({ field, draw, action, screen }: RenderEvent) {
      this.screen = screen;
      return (
        <Layout>
          {draw(this.grid)}
          {this.renderUploadModal()}
        </Layout>
      );
    }

    getActiveEmployees() {
      let array = this.state.allEmployees;
      array.rows = array.rows.filter(x => x.IsActive && x.BenefitEndDate == null)
      .sort((a, b) => 
        a.LastName?.localeCompare(b.LastName) || 
        a.FirstName?.localeCompare(b.FirstName)
      );
      return array;
    }
    

    getPendingInactiveEmployees() {
      let array = this.state.allEmployees;
      array.rows = array.rows.filter(x => x.IsActive && x.BenefitEndDate != null)
      .sort((a, b) => 
        a.LastName?.localeCompare(b.LastName) || 
        a.FirstName?.localeCompare(b.FirstName)
      );
      return array;
    }

    getInactiveEmployees() {
      let array = this.state.allEmployees;
      var now = new Date();
      array.rows = array.rows.filter(x => x.IsActive == false && new Date(x.BenefitEndDate) <= now)
      .sort((a, b) => 
        a.LastName?.localeCompare(b.LastName) || 
        a.FirstName?.localeCompare(b.FirstName)
      );;
      return array;
    }

    toggleInactiveEmployees(e){
      this.setState({
        showDeactivatedEmployees : e.target.checked,
        firstRun: false
      });

      if(e.target.checked){
        this.setState({ filteredEmployees: this.getInactiveEmployees() });
      } else {
        this.setState({ filteredEmployees: this.getActiveEmployees() });
      }
    }

    toggelPendingDeactivaed(e){
      this.setState({
        showPendingDeactivatedEmployees : e.target.checked,
        firstRun: false
      });

      if(e.target.checked){
        this.setState({ filteredEmployees: this.getPendingInactiveEmployees() });
      } else {
        this.setState({ filteredEmployees: this.getActiveEmployees() });
      }
    }

    grid({ field, draw, action, collection }: RenderEvent) {
      this.state.allEmployees = collection("@dsEmployees");

      if (this.state.firstRun) {
        this.state.filteredEmployees = this.state.showDeactivatedEmployees
          ? this.getInactiveEmployees()
          : this.getActiveEmployees();
        this.state.allEmployees = collection("@dsEmployees");
        this.state.firstRun = false;
      }

      let actions = (
        <>
          <Button
            className="add-employee"
            action={action(this.add)} 
            label="Add Employee" 
            style="add" 
          />
          <Button
            className="add-employee"
            action={action(this.upload)} 
            label="Upload Employee" 
            style="add" 
          />
          <input 
            className="RT-TextBox__input" 
            type="text" 
            placeholder="Search" 
            id="empSearch" 
            onKeyPress={this.handleKeyPress} 
            value={this.state.filterText} 
            onChange={this.handleChange.bind(this)} 
            style={{ backgroundColor: "white", width: "auto", height: "26px" }}
          />
          <button
            className="RT-Button RT-Button--primary"
            disabled={this.state.submitDisabled}
            onClick={this.handleClick.bind(this)}
          >
            Submit
          </button>
          <button
            className="RT-Button RT-Button--primary"
            onClick={this.reset.bind(this)}
          >
            Reset
          </button>
          <label>
            <input
              type="checkbox"
              checked={this.state.showDeactivatedEmployees}
              onChange={this.toggleInactiveEmployees.bind(this)}
              style={{ paddingLeft: 0, marginRight: 10 }}
            />
            Include deactivated employees
          </label>
          <label>
            <input
              type="checkbox"
              checked={this.state.showPendingDeactivatedEmployees}
              onChange={this.toggelPendingDeactivaed.bind(this)}
              style={{ paddingLeft: 0, marginRight: 10 }}
            />
            Show pending deactivated employees
          </label>
        </>
      );

      let layout: IDataGridLayout = {
        columns: [
          {
            name: "LastName",
            label: "Last Name",
            type: "character",
            width: 200,
          },
          {
            name: "FirstName",
            label: "First Name",
            type: "character",
            width: 200,
          },
          { name: "Email", 
            label: "Email", 
            type: "character", 
            width: 300 
          },
          {
            name: "HireDate",
            label: "Date Of Hire",
            type: "date",
            width: 203,
          },
          {
            name: "BenefitStartDate",
            label: "Benefit Start Date",
            type: "date",
            width: 150,
          },
          {
            name: "Coverage",
            label: "Coverage",
            type: "character",
            width: 150,
          },
          {
            name: "IsPlanAdmin",
            label: "Is Plan Admin",
            type: "logical",
            width: 150,
          },
          {
            name: "BenefitCategory",
            label: "Benefit Category",
            type: "character",
            width: 200,
          },
          {
            name: "BenefitEndDate",
            label: "Benefit End Date",
            type: "date",
            width: 150,
          },
          {
            name: "CreatedAt",
            label: "Created At",
            type: "date",
            width: 150,
          },
          {
            name: "CreatedByName",
            label: "Created By",
            type: "character",
            width: 200,
          },
        ],
        sort: [{ name: "LastName" }, { name: "FirstName" }],
      };

      return (
        <DataGrid
          collection={this.state.filteredEmployees}
          layout={layout}
          actions={actions}
          onRowClick={action(this.open_row)}
        />
      );
    }

    empty_state({ field, draw, action, screen }: RenderEvent) {
      this.screen = screen;
      return (
        <EmptyState label="No employees created yet." icon="users">
          <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
            <Button action={action(this.add)} label="Add Employee" style="primary" />
            <Button action={action(this.upload)} label="Upload Employee" style="primary" />
          </div>
          {this.renderUploadModal()}
        </EmptyState>
      );
    }

    async add({ screen }: ActionEvent) {
      const isDisabled = await this.checkIsEligibleToAddEmployee();
      if(isDisabled){
        toastr.error("You are not eligible to add employee. Please complete the Product and Benefit categories setup.");
        return;
      }

      await screen.openDialog(
        <EmployeeAddScreen policy_id={this.props.policy_id} />,
        { onRecordChanged: this.refresh_row }
      );

      await screen.restart();
    }

    async upload({ screen }: ActionEvent) {
      const isDisabled = await this.checkIsEligibleToAddEmployee();
      if (isDisabled) {
        toastr.error("You are not eligible to upload employee...");
        return;
      }
      this.screen = screen;
      // Mirror the Add Employee flow (action awaits the dialog, then restarts
      // the screen): block here until the modal closes, then refresh the list.
      // The action-level spinner would otherwise stay up the entire time the
      // modal is open — pause it the same way Dialog.open does.
      const spinner = (screen as any).canvas?.app?.spinner;
      spinner?.pause();
      try {
        await new Promise<void>((resolve) => {
          this.uploadModalCloseResolver = resolve;
          this.setState({ showUploadModal: true });
        });
      } finally {
        spinner?.resume();
      }
      await screen.restart();
    }

    async open_row({ screen }: ActionEvent) {
      screen.browse(
        <EmployeeRecordScreen employee_id={screen.getValue("Id")} />,
        { onRecordChanged: this.refresh_row, label: "Employee" }
      );
    }

    async refresh_row({ screen, eventValue }: ActionEvent) {
      screen.showLayout(this.main);
      await KTMApi.refreshRow(screen, {
        collection: "@dsEmployees",
        rowid: eventValue,
      });
    }
  }
);
